export const PULSE_FUND_PREFILL_KEY = 'pulse-fund-prefill';

export function buildPulseFundPrefill(fund, fromFundPage = false) {
  const { id, name, descriptionShort, avatar } = fund;
  return { id, name, descriptionShort, avatar, fromFundPage };
}

export function savePulseFundPrefillToLocalStorage(fund, fromFundPage = false) {
  if (!import.meta.client || !fund?.id) {
    return;
  }

  localStorage.setItem(
    PULSE_FUND_PREFILL_KEY,
    JSON.stringify(buildPulseFundPrefill(fund, fromFundPage)),
  );
}

export function mapFundPrefillToFundDetails(prefill) {
  const { id, name, descriptionShort, avatar } = prefill;
  return { id, name, descriptionShort, avatar };
}

export function consumeFundPrefillFromLocalStorage() {
  if (!import.meta.client) {
    return null;
  }

  const raw = localStorage.getItem(PULSE_FUND_PREFILL_KEY);

  if (!raw) {
    return null;
  }

  localStorage.removeItem(PULSE_FUND_PREFILL_KEY);

  try {
    const prefill = JSON.parse(raw);
    return prefill?.id ? prefill : null;
  } catch {
    return null;
  }
}
